import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "page-content" }
const _hoisted_5 = { class: "page-content section" }
const _hoisted_6 = { id: "estateAgencyProfile" }
const _hoisted_7 = { class: "width-wrap" }
const _hoisted_8 = { class: "form-header" }
const _hoisted_9 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_10 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_11 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_12 = { class: "width-wrap" }
const _hoisted_13 = { class: "form-section has-aside" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { for: "frm-registerForm_title" }
const _hoisted_16 = {
  key: 0,
  class: "form-error"
}
const _hoisted_17 = { for: "frm-registerForm_idNumber" }
const _hoisted_18 = {
  key: 0,
  class: "form-error"
}
const _hoisted_19 = {
  key: 1,
  class: "form-error"
}
const _hoisted_20 = { for: "frm-registerForm_email" }
const _hoisted_21 = {
  key: 0,
  class: "form-error"
}
const _hoisted_22 = { for: "frm-registerForm_website" }
const _hoisted_23 = {
  key: 0,
  class: "form-error"
}
const _hoisted_24 = {
  key: 1,
  class: "form-error"
}
const _hoisted_25 = { for: "frm-registerForm_phone" }
const _hoisted_26 = { class: "input-with-button" }
const _hoisted_27 = {
  key: 0,
  class: "form-error"
}
const _hoisted_28 = {
  key: 1,
  class: "form-error"
}
const _hoisted_29 = ["for"]
const _hoisted_30 = { class: "input-with-button" }
const _hoisted_31 = ["id", "onUpdate:modelValue", "name"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "form-error"
}
const _hoisted_34 = { for: "frm-registerForm_description" }
const _hoisted_35 = {
  key: 0,
  class: "form-error"
}
const _hoisted_36 = {
  key: 0,
  class: "form-section-aside"
}
const _hoisted_37 = { class: "form-upload-photo aspect-ratio aspect-ratio-16-9" }
const _hoisted_38 = { class: "aspect-ratio-body" }
const _hoisted_39 = {
  key: 0,
  class: "photo bordered is-uploaded"
}
const _hoisted_40 = {
  key: 1,
  class: "upload-placeholder placeholder-empty"
}
const _hoisted_41 = { class: "upload-placeholder-title" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = {
  key: 0,
  class: "form-error"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "line-sep" }, null, -1)
const _hoisted_46 = { class: "width-wrap" }
const _hoisted_47 = { class: "form-heading" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = { for: "frm-registerForm_invoiceStreet" }
const _hoisted_50 = {
  key: 0,
  class: "form-error"
}
const _hoisted_51 = { for: "frm-registerForm_invoiceZip" }
const _hoisted_52 = {
  key: 0,
  class: "form-error"
}
const _hoisted_53 = { for: "frm-registerForm_invoiceCity" }
const _hoisted_54 = {
  key: 0,
  class: "form-error"
}
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { for: "frm-registerForm_vatIdNumber" }
const _hoisted_57 = {
  key: 0,
  class: "form-error"
}
const _hoisted_58 = {
  key: 1,
  class: "form-error"
}
const _hoisted_59 = { for: "frm-registerForm_taxIdNumber" }
const _hoisted_60 = {
  key: 0,
  class: "form-error"
}
const _hoisted_61 = {
  key: 1,
  class: "form-error"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "line-sep" }, null, -1)
const _hoisted_63 = { class: "width-wrap" }
const _hoisted_64 = { class: "form-heading" }
const _hoisted_65 = { class: "form-group" }
const _hoisted_66 = { for: "frm-registerForm_backOfficeConsumerKey" }
const _hoisted_67 = {
  key: 0,
  class: "form-error"
}
const _hoisted_68 = {
  key: 1,
  class: "form-error"
}
const _hoisted_69 = { for: "frm-registerForm_backOfficeConsumerSecret" }
const _hoisted_70 = {
  key: 0,
  class: "form-error"
}
const _hoisted_71 = { class: "width-wrap" }
const _hoisted_72 = { class: "form-footer" }
const _hoisted_73 = { class: "buttons" }
const _hoisted_74 = { class: "button button--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapPosition = _resolveComponent("MapPosition")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Cropper = _resolveComponent("Cropper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            id: "estateAgencyProfile-form",
            class: "form",
            onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"])),
            autocomplete: "off"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.form-header')), 1)
              ]),
              (_ctx.showFormMessages)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.isSuccess)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.success-message')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.isError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flashmessage flash-danger"
                      }, _toDisplayString(error), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.title.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.agency-title')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.title.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_title",
                      name: "title",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.title.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.title.$dirty && _ctx.v$.form.title.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.title.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.idNumber.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.invoice-idnumber')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.idNumber.$model) = $event)),
                      type: "text",
                      disabled: "",
                      id: "frm-registerForm_idNumber",
                      name: "idNumber",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.idNumber.$model,
                        void 0,
                        {
                          trim: true,
                          lazy: true
                        }
                      ]
                    ]),
                    (_ctx.v$.form.idNumber.$dirty && _ctx.v$.form.idNumber.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.idNumber.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.idNumber.maxLength.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.idNumber.maxLength.$params.max })), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.email')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_email",
                      name: "email",
                      class: "form-control is-required",
                      autocapitalize: "off"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.email.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.email.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.website.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.website')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.website.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_website",
                      name: "website",
                      class: "form-control",
                      autocapitalize: "off"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.website.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.website.$dirty && _ctx.v$.form.website.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.website.required && _ctx.v$.form.website.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.website.url.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('forms.url')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.phone.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.phoneNumber')) + ":", 1),
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.form.phone.$model) = $event)),
                        type: "text",
                        id: "frm-registerForm_phone",
                        name: "phone",
                        placeholder: "+421 900 000 000",
                        class: "form-control is-required"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.phone.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        class: "clone",
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.phoneNumbers.push('')))
                      })
                    ]),
                    (_ctx.v$.form.phone.$dirty && _ctx.v$.form.phone.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.phone.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.phone.phoneNumber.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.phoneNumbers, (phone, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "form-field",
                      key: index
                    }, [
                      _createElementVNode("label", {
                        for: 'frm-registerForm_phone' + index
                      }, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.phoneNumber')) + ":", 9, _hoisted_29),
                      _createElementVNode("div", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: 'frm-registerForm_phone' + index,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.form.phoneNumbers[index]) = $event),
                          placeholder: "+421 900 000 000",
                          name: 'phone' + index,
                          class: "form-control"
                        }, null, 8, _hoisted_31), [
                          [
                            _vModelText,
                            _ctx.form.phoneNumbers[index],
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          class: "remove",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removePhoneNumber(index))
                        }, null, 8, _hoisted_32)
                      ])
                    ]))
                  }), 128)),
                  _createVNode(_component_MapPosition, {
                    position: _ctx.initialPosition,
                    onAddressChanged: _ctx.onAddressChanged,
                    hasError: _ctx.v$.form.address.$error,
                    label: "Adresa"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.v$.form.address.$dirty && _ctx.v$.form.address.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.address.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["position", "onAddressChanged", "hasError"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field full-width", { 'is-danger': _ctx.v$.form.description.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.description')) + ":", 1),
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.form.description.$model) = $event)),
                      type: "text",
                      id: "frm-registerForm_description",
                      name: "description",
                      class: "form-control",
                      rows: "5"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.description.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (_ctx.v$.form.description.$dirty && _ctx.v$.form.description.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.description.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                (_ctx.estateAgencyImage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'is-danger': _ctx.estateAgencyImage.isError }])
                      }, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            (_ctx.estateAgencyImage.isSuccess)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  (_ctx.estateAgencyImage.isSuccess)
                                    ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                        key: 0,
                                        url: _ctx.estateAgencyImage.url,
                                        width: 320,
                                        height: 180,
                                        hrmode: "max",
                                        alt: _ctx.estateAgencyImage.file,
                                        draggable: false
                                      }, null, 8, ["url", "alt"]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", {
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteEstateAgencyFile())),
                                    class: "delete-photo"
                                  }),
                                  _createElementVNode("span", {
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.editEstateAgencyFile())),
                                    class: "edit-photo"
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("label", _hoisted_40, [
                                  _createElementVNode("input", {
                                    type: "file",
                                    accept: "image/png, image/jpeg",
                                    ref: "estateAgencyImage",
                                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleEstateAgencyImageUpload()))
                                  }, null, 544),
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.logo-button')), 1),
                                  _createElementVNode("i", {
                                    innerHTML: _ctx.$t('EstateAgencyProfileEdit.logo-button-info')
                                  }, null, 8, _hoisted_42)
                                ])),
                            (_ctx.estateAgencyImage.isUploading)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "progress-bar",
                                  style: _normalizeStyle({ width: _ctx.estateAgencyImage.uploadPercentage + '%' })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.estateAgencyImage.isError)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.estateAgencyImage.text), 1))
                          : _createCommentVNode("", true)
                      ], 2),
                      (_ctx.estateAgencyImage.isSuccess)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                            _createTextVNode(_toDisplayString(_ctx.$t('EstateAgencyProfileEdit.logo-edit1')) + " ", 1),
                            _createElementVNode("a", {
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editEstateAgencyFile()))
                            }, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.logo-edit2')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.form-header-invoice-data')), 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.invoiceStreet.$error }])
                }, [
                  _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.invoice-street')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v$.form.invoiceStreet.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_invoiceStreet",
                    name: "invoiceStreet",
                    class: "form-control is-required"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.invoiceStreet.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.invoiceStreet.$dirty && _ctx.v$.form.invoiceStreet.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.invoiceStreet.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.invoiceZip.$error }])
                }, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.invoice-zip')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v$.form.invoiceZip.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_invoiceZip",
                    name: "invoiceZip",
                    class: "form-control is-required"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.invoiceZip.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.invoiceZip.$dirty && _ctx.v$.form.invoiceZip.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.invoiceZip.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.invoiceCity.$error }])
                }, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.invoice-city')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v$.form.invoiceCity.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_invoiceCity",
                    name: "invoiceCity",
                    class: "form-control is-required"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.invoiceCity.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.invoiceCity.$dirty && _ctx.v$.form.invoiceCity.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.invoiceCity.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.vatIdNumber.$error }])
                }, [
                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.invoice-vatidnumber')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.v$.form.vatIdNumber.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_vatIdNumber",
                    name: "vatIdNumber",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.vatIdNumber.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.vatIdNumber.$dirty && _ctx.v$.form.vatIdNumber.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.vatIdNumber.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.vatIdNumber.maxLength.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.vatIdNumber.maxLength.$params.max })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.taxIdNumber.$error }])
                }, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.invoice-taxidnumber')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.v$.form.taxIdNumber.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_taxIdNumber",
                    name: "taxIdNumber",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.taxIdNumber.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.taxIdNumber.$dirty && _ctx.v$.form.taxIdNumber.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.taxIdNumber.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.taxIdNumber.maxLength.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.taxIdNumber.maxLength.$params.max })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]),
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.form-header-backoffice')), 1)
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.backOfficeConsumerKey.$error }])
                }, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.backOfficeConsumerKey')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.v$.form.backOfficeConsumerKey.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_vatIdNumber",
                    name: "backOfficeConsumerKey",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.backOfficeConsumerKey.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.backOfficeConsumerKey.$dirty && _ctx.v$.form.backOfficeConsumerKey.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.backOfficeConsumerKey.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true),
                        (_ctx.v$.form.backOfficeConsumerKey.maxLength.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.$t('forms.max', { count: _ctx.v$.form.backOfficeConsumerKey.maxLength.$params.max })), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.backOfficeConsumerSecret.$error }])
                }, [
                  _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.backOfficeConsumerSecret')) + ":", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.v$.form.backOfficeConsumerSecret.$model) = $event)),
                    type: "text",
                    id: "frm-registerForm_backOfficeConsumerSecret",
                    name: "backOfficeConsumerSecret",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.v$.form.backOfficeConsumerSecret.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.form.backOfficeConsumerSecret.$dirty && _ctx.v$.form.backOfficeConsumerSecret.$invalid)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.v$.form.backOfficeConsumerSecret.required.$invalid)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.$t('forms.required')), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("button", _hoisted_74, _toDisplayString(_ctx.$t('EstateAgencyProfileEdit.button-save')), 1),
                  _createVNode(_component_router_link, {
                    to: { name: 'EstateAgencyProfile' },
                    tag: "button",
                    class: "button button--primary reversed"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('EstateAgencyProfileEdit.button-cancel')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    (_ctx.showEstateAgencyImageModal)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#container"
        }, [
          _createVNode(_component_Cropper, {
            img: _ctx.estateAgencyImage.url,
            fileName: _ctx.estateAgencyImage.file,
            aspectRatio: 16 / 9,
            accept: "image/png",
            onUpload: _ctx.uploadEstateAgencyImage,
            onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showEstateAgencyImageModal = false))
          }, null, 8, ["img", "fileName", "onUpload"])
        ]))
      : _createCommentVNode("", true)
  ]))
}